import { Card, Spin, Tooltip, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { TicketDetail } from 'types';
import { requestform } from 'messages';
import { PrinterIcon } from 'assets';
import { GetTicketDetail } from 'hooks/request-form';
import defaultTicketDetail from 'types/dto/request-form/request-form.dto';
import PrintComponent from '../print-ticket/PrintTikcet';
import NormalTicket from '../print-ticket-detail/NormalTicket';
import { useReactToPrint } from 'react-to-print';
import RequestDetailCreateFormInformation from '../request-form/RequestDetailCreateFormInformation';
import RequestStatusBar from 'components/request-form/RequestStatusBar';
import RequestDetailMainInformation from '../request-form/RequestDetailMainInformation';
import RequestDetailProcessing from '../request-form/RequestDetailProcessing';
import RequestDetailCmisTransferInformation from '../request-form/RequestDetailCmisTransferInformation';

interface ticketFromDetail {
  status?: string;
  ticketId: number;
  cancelDetailModal: () => void;
  fieldTaskCaseIds?: number[];
  setInprogressTicket?: React.Dispatch<React.SetStateAction<number>>;
}

const TicketDetailDtv: React.FC<ticketFromDetail> = ({
  status = 'pending_reception',
  ticketId,
  cancelDetailModal,
  fieldTaskCaseIds,
  setInprogressTicket
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  // Main request detail
  const [ticketStatus, setTicketStatus] = useState(status);
  const [requestTicketId, setRequestTicketId] = useState<number>(ticketId);
  const { requestDetail, isLoading } = GetTicketDetail(requestTicketId);

  const [requestItem, setRequestItem] = useState<TicketDetail>(defaultTicketDetail);

  const checkTicketStatus: { [key in 6 | 7 | 8]: string } = {
    6: 'pending_reception',
    7: 'in_progress',
    8: 'completed'
  } as const;
  type StatusId = keyof typeof checkTicketStatus;
  const getStatus = (statusId: number): string => {
    return checkTicketStatus[statusId as StatusId] ?? 'pending_reception';
  };

  useEffect(() => {
    setRequestItem(requestDetail);

    if (requestDetail?.statusId !== undefined && [6, 7, 8].includes(requestDetail.statusId))
      setTicketStatus(getStatus(requestDetail.statusId));
  }, [requestDetail]);

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.requestTicket} {requestDetail.ticketId}
        </Typography.Text>
      }
      className='request-form-detail-card text-center'
    >
      <div style={{ display: 'none' }}>
        <PrintComponent ref={contentRef}>
          <NormalTicket ticket={requestDetail} status={status} ticketId={ticketId} isHistory={false} />
        </PrintComponent>
      </div>

      <div className='flex w-full text-left'>
        <div className='w-[250px]'>
          <RequestDetailCreateFormInformation requestItem={requestItem} />
        </div>

        {isLoading ? (
          <div className='h-[calc(95vh-8rem) flex w-[870px] items-center justify-center'>
            <Spin tip={'Đang tải'} size={'large'} />
          </div>
        ) : (
          <section className='flex flex-col'>
            <section className='h-full w-[870px] overflow-y-auto overflow-x-hidden p-6'>
              <section className='flex items-center justify-between'>
                <div className='w-4/5'>
                  <Tooltip
                    title={
                      requestItem?.serviceType && requestItem?.serviceType?.name ? requestItem?.serviceType?.name : ''
                    }
                  >
                    <Typography.Text className='text-[26px]/[34px] font-bold text-[#141414]'>
                      {requestItem?.serviceType && requestItem?.serviceType?.name
                        ? requestItem?.serviceType?.name?.split(' ').slice(0, 10).join(' ') +
                          (requestItem?.serviceType?.name.split(' ').length > 10 ? ' ...' : '')
                        : ''}
                    </Typography.Text>
                  </Tooltip>
                </div>
                <button onClick={() => reactToPrintFn()} className='flex items-center space-x-2'>
                  <PrinterIcon />
                  <Typography.Text className='text-[16px]/[20px] text-[#1564E8]'>
                    {requestform.printTicket}
                  </Typography.Text>
                </button>
              </section>

              <section>
                <Typography.Text
                  className={`text-[14px]/[18px] font-normal italic ${
                    requestItem?.numOfRequests > 5
                      ? 'text-[#D1131D]'
                      : requestItem?.numOfRequests > 3
                        ? 'text-[#FF9500]'
                        : 'text-[#6C737E]'
                  }`}
                >
                  {requestform.customerContact} {requestItem?.numOfRequests || 0} {requestform.customerContractTime}
                </Typography.Text>
              </section>

              <section className='pb-6'>
                <RequestStatusBar status={ticketStatus} />
                {requestItem?.serviceTypeId == 1 ||
                requestItem?.serviceTypeId == 3 ||
                requestItem?.serviceTypeId == 4 ? (
                  ''
                ) : (
                  <RequestDetailCmisTransferInformation ticketDetail={requestItem} isHistory={false} />
                )}
              </section>

              <section
                className={`${
                  status === 'completed' ||
                  (requestItem?.serviceTypeId != 1 &&
                    requestItem?.serviceTypeId != 3 &&
                    requestItem?.serviceTypeId != 4) ||
                  false
                    ? 'max-h-[calc(90vh-20rem)] overflow-y-auto'
                    : 'max-h-[calc(90vh-17rem)] overflow-y-auto'
                }`}
              >
                <RequestDetailMainInformation requestItem={requestItem} />
                <RequestDetailProcessing
                  //Use for customer history request
                  isHistory={false}
                  requestItem={requestItem}
                  processingContent={''}
                />
              </section>
            </section>
          </section>
        )}
      </div>
    </Card>
  );
};

export default TicketDetailDtv;
